import { Toast, ToastProvider, ToastViewport } from "@/components/ui/toast";
import { useToast } from "@/lib/toast";
import { B24Notification } from "@/components/ui/B24Notification";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, variant, duration, undo, ...props }) => {
        // Map Radix variant/duration to B24Notification
        const b24Variant = variant === "destructive" ? "error" : (variant as any) || "info";

        return (
          <Toast key={id} variant="b24" duration={duration} {...props}>
            <B24Notification
              title={String(title || "")}
              message={String(description || "")}
              variant={b24Variant}
              duration={duration}
              undo={undo}
            />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
